"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appVerificationTypes = void 0;
var appVerificationTypes;
(function (appVerificationTypes) {
    appVerificationTypes["MOBILE_NUMBER"] = "mobileNumber";
    appVerificationTypes["INVITE_CODE"] = "inviteCode";
    appVerificationTypes["DATE_OF_BIRTH"] = "dateOfBirth";
})(appVerificationTypes || (exports.appVerificationTypes = appVerificationTypes = {}));
